import React from 'react';

const SvgImgPay = props => (
  <svg
    id="img_pay_svg__Component_8"
    data-name="Component 8"
    width="1em"
    height="1em"
    viewBox="0 0 50 50"
    {...props}
  >
    <defs>
      <linearGradient
        id="img_pay_svg__linear-gradient"
        x1={0.033}
        x2={1}
        y2={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#6dacff" />
        <stop offset={1} stopColor="#104eb2" />
      </linearGradient>
      <style>{'.img_pay_svg__cls-2{fill:#fff}'}</style>
    </defs>
    <path
      id="img_pay_svg__ic_cupon"
      d="M2.013 0h45.974A2.013 2.013 0 0150 2.013v45.974A2.013 2.013 0 0147.987 50H2.013A2.013 2.013 0 010 47.987V2.013A2.013 2.013 0 012.013 0z"
      fill="url(#img_pay_svg__linear-gradient)"
    />
    <g id="img_pay_svg__save-money" transform="translate(10.235 11.915)">
      <path
        id="img_pay_svg__Path_528"
        data-name="Path 528"
        className="img_pay_svg__cls-2"
        d="M188.45 155.255a.527.527 0 00-.19-.007 1.26 1.26 0 01-1.114-1.248.554.554 0 00-1.108 0 2.371 2.371 0 001.743 2.282v.554a.554.554 0 001.108 0v-.521a2.366 2.366 0 00-.485-4.682 1.258 1.258 0 111.258-1.258.554.554 0 101.108 0 2.371 2.371 0 00-1.881-2.316v-.5a.554.554 0 00-1.108 0v.538a2.366 2.366 0 00.623 4.649 1.257 1.257 0 01.046 2.514zm0 0"
        transform="translate(-173.177 -144.194)"
      />
      <path
        id="img_pay_svg__Path_529"
        data-name="Path 529"
        className="img_pay_svg__cls-2"
        d="M104.2 114.527a8.035 8.035 0 108.035-8.035 8.035 8.035 0 00-8.035 8.035zm8.035-6.927a6.927 6.927 0 11-6.927 6.927 6.927 6.927 0 016.922-6.927zm0 0"
        transform="translate(-97.003 -106.492)"
      />
      <path
        id="img_pay_svg__Path_530"
        data-name="Path 530"
        className="img_pay_svg__cls-2"
        d="M26.354 328.564l-4.341 2.051a3.535 3.535 0 00-3.013-1.86l-4.007-.11a4.232 4.232 0 01-1.821-.47l-.408-.211a7.192 7.192 0 00-6.662.007l.025-.924a.554.554 0 00-.539-.569l-4.394-.121a.554.554 0 00-.569.539l-.265 9.641a.554.554 0 00.539.569l4.394.121h.015a.554.554 0 00.554-.539l.013-.461 1.142-.611a1.958 1.958 0 011.461-.16l6.817 1.913.036.009a7.294 7.294 0 001.5.154 7.393 7.393 0 003.088-.674.512.512 0 00.069-.038l9.883-6.393a.554.554 0 00.182-.738 2.8 2.8 0 00-3.7-1.126zm-24.871 7.45l.235-8.535L5 327.57l-.231 8.53zm17.934-.145a6.283 6.283 0 01-3.842.429l-6.8-1.908a3.064 3.064 0 00-2.284.25l-.583.313.156-5.674a6.091 6.091 0 016.188-.33l.408.211a5.352 5.352 0 002.3.594l4.007.11a2.43 2.43 0 012.31 1.937l-5.969-.165a.554.554 0 00-.031 1.108l6.587.181h.015a.554.554 0 00.554-.539 3.517 3.517 0 00-.054-.719l4.452-2.1.013-.006a1.693 1.693 0 011.914.268zm0 0"
        transform="translate(-.36 -311.127)"
      />
    </g>
  </svg>
);

export default SvgImgPay;
